import type {RouteRecordRaw} from 'vue-router';

import {route as personalAccount} from './cabinet';
import {route as mainPage, routeName as mainName} from './main';
import {route as externalDocPage} from './externalDoc';
import {route as mainTariffs} from './tariffs';
import {route as mainValidate} from './validate';
import {route as mainValidateById} from './validate_by_id';

export const routes: readonly RouteRecordRaw[] = [
    {
        path: '/',
        name: 'root',
        redirect: {
            name: mainName
        },
        children: [
            mainPage,
            {
                path: '/',
                name: 'main-layout',
                component: () => import('@/app/layouts/MainLayout'),
                children: [
                    externalDocPage,
                    mainTariffs,
                    mainValidate,
                    mainValidateById,
                ]
            },
            personalAccount,
            {
                path: '/:pathMatch(.*)*',
                name: 'NotFound',
                component: () => import('@/app/layouts/MainLayout'),
                children: [
                    {
                        path: '',
                        name: 'NotFoundChild',
                        component: () => import("@/pages/NotFound"),
                    }
                ]
            },
        ]
    },
] as const;
